module.exports = __webpack_public_path__ + "static/media/mojo5.caf07410.webp";